// extracted by mini-css-extract-plugin
module.exports = {"feature":"b7_ld","feature_negative":"b7_lf","feature__icon":"b7_lg","feature__description":"b7_lh"};